<template>
  <div >
    <el-dialog  title="排号列表" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible="PHxuansijiFlag" width="900px" center  append-to-body>
      <div>
         <!-- 头部查询 -->
          <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
            <div class=" inpBox">
              <el-form-item label="司机姓名:">
              <el-input  placeholder="" v-model="SJsearchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="车牌号:">
              <el-input  placeholder="" v-model="SJsearchFrom.vhcNo"></el-input>
            </el-form-item>
            <el-form-item label="车辆类型:" prop="vhcTypeId" >
                <el-select placeholder="请选择" v-model="SJsearchFrom.vhcTypeId">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
            <el-form-item label="能源类型:" prop="energyId">
                <el-select placeholder="请选择" v-model="SJsearchFrom.energyId">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.id"
                    :label="item.energyName"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
            <el-form-item >
                <el-button type="primary" @click="SJsearchFn">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="resetForm()">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
          <!-- 表格数据 -->
          <div>
            <!-- 表格 -->
            <div>
              <el-table
                :data="SJList"
                ref="table"
                bordersize="mini"
                @row-click="handleRowClick"
                class="table"
                height="380px"
                style="width: 100%"
                center
                border
              >
                <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
                <el-table-column  type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="SJZPfn(scope.row,2)" size="mini">指派</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="driverName" min-width="130"  label="司机姓名"></el-table-column>
                <el-table-column prop="driverPhone" min-width="130"  label="司机电话"></el-table-column>
                <el-table-column prop="vhcNo" min-width="130"  label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName" min-width="140"  label="车辆类型"></el-table-column>
                <el-table-column prop="energyTypeName" min-width="90"  label="能源类型"></el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <!-- <div>
              <el-pagination background
                @size-change="SJhandleSizeChange"
                @current-change="SJhandleCurrentChange"
                :current-page="SJsearchFrom.pageNo"
                :page-sizes="[25,50,100]"
                :page-size="SJsearchFrom.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="SJtotal">
              </el-pagination>
            </div> -->
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { relList } from '@/api/newTMS'
import { cVTlist, cVhcEnergyTypeList } from '@/api/vgs-driver2.0'
export default {
  name: 'guanlianhetong',
  props: {
    PHxuansijiFlag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      addFrom: {},
      SJsearchFrom: {
      },
      SJList: [],
      SJtotal: 0,
      vehicleT: [],
      NYtype: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    cVTlist({}).then(res => {
      this.vehicleT = res
      this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    this.SJsearchFn()
  },
  methods: {
    // 司机指派
    SJZPfn (row, n) {
      this.$emit('selectCar', row)
      this.$emit('update:PHxuansijiFlag', false)
    },
    carOk (row) {
    },
    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      searchFrom.queueStatus = 0
      relList(searchFrom).then(res => {
        this.SJList = res
      })
    },
    // 每页条数
    SJhandleSizeChange (val) {
      this.SJsearchFrom.pageSize = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 当前页
    SJhandleCurrentChange (val) {
      this.SJsearchFrom.pageNo = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.ccarFrom = {}
    },
    closeDialog () {
      this.$emit('update:PHxuansijiFlag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>

</style>
